import React from 'react';
import { Typography, Paper, Grid, Avatar } from '@mui/material';
import { ToppingsInterface } from '../../../store/sellingCakeReport/api/interface';
import { getAssetURl } from '../../../utils/url';
import { isValidArray } from '../../../utils/valid';
import { useAppSelector } from '../../../store';

interface IProps {
  topSellingToppings: ToppingsInterface[] | undefined;
  lessSellingToppings: ToppingsInterface[] | undefined;
}

const Toppings: React.FC<IProps> = ({
  topSellingToppings,
  lessSellingToppings,
}) => {
  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  return (
    <Paper
      elevation={3}
      sx={{ padding: 2, height: '100%' }}
    >
      <Typography
        variant='h6'
        gutterBottom
      >
        Toppings
      </Typography>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Most Sold</Typography>
        </Grid>
        {!isValidArray(topSellingToppings) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {topSellingToppings?.map((topping) => (
          <Grid
            item
            xs={6}
            key={topping?.labelEn}
          >
            <Avatar
              alt={topping?.previewUrl}
              imgProps={{ crossOrigin: 'anonymous' }}
              src={getAssetURl(topping?.previewUrl, assetUrl)}
              sx={{
                borderRadius: 'unset',
                m: 1,
                objectFit: 'contain',
                '& img': { objectFit: 'contain' },
                width: '100%',
              }}
            />
            <Typography
              variant='body1'
              align='center'
            >
              {topping?.labelEn} (Sold:{topping?.totalQuantitySold})
            </Typography>
          </Grid>
        ))}
        <Grid
          item
          xs={12}
        >
          <Typography variant='subtitle1'>Least Sold</Typography>
        </Grid>
        {!isValidArray(lessSellingToppings) && (
          <div className='center-class'>
            <Typography variant='body2'>{'No record found'}</Typography>
          </div>
        )}
        {lessSellingToppings?.map((topping) => (
          <Grid
            item
            xs={6}
            key={topping?.labelEn}
          >
            <Avatar
              alt={topping?.previewUrl}
              imgProps={{ crossOrigin: 'anonymous' }}
              src={getAssetURl(topping?.previewUrl, assetUrl)}
              sx={{
                borderRadius: 'unset',
                m: 1,
                objectFit: 'contain',
                '& img': { objectFit: 'contain' },
                width: '100%',
              }}
            />
            <Typography
              variant='body1'
              align='center'
            >
              {topping?.labelEn} (Sold:{topping?.totalQuantitySold})
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default Toppings;
